import { ReactNode } from 'react'

import {
  IconDefinition,
  faCircleExclamation,
  faClipboardList,
  faListCheck,
  faFolder,
  faHouse,
  faSquareDashed,
} from '@fortawesome/pro-regular-svg-icons'

export enum UniversalSearchOptionType {
  Address,
  Parcel,
  Record,
  Violation,
  Condition,
}

export const UniversalSearchOptionTypeToIconDefinitionMap: Record<
  UniversalSearchOptionType,
  IconDefinition
> = {
  [UniversalSearchOptionType.Address]: faHouse,
  [UniversalSearchOptionType.Parcel]: faSquareDashed,
  [UniversalSearchOptionType.Record]: faFolder,
  [UniversalSearchOptionType.Violation]: faCircleExclamation,
  [UniversalSearchOptionType.Condition]: faListCheck,
}

export const ChildRecordIcon: IconDefinition = faClipboardList

export type UniversalSearchOption = {
  type: UniversalSearchOptionType
  title: string
  subtitle: ReactNode
  subtitleSortString: string
  url: string
  uuid: string
  isChildRecord?: boolean
  parentUuid?: string
}

export type UniversalSearchType = {
  label: string
  mode: 'all' | 'addresses' | 'parcels' | 'records' | 'violations' | 'conditions'
  recordTypeId?: number
}
